import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-force-logout-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfForceLogoutIconProps extends SvgIconProps {}

/**
 * Icon to show force logout
 * @param props - CcfForceLogoutIconProps
 * @example  <CcfForceLogoutIcon />
 * @returns
 */
export function CcfForceLogoutIcon(props: CcfForceLogoutIconProps) {
  return (
    <SvgIcon {...props} width="17.995" height="18" viewBox="0 0 17.995 18">
      <g
        id="Component_420"
        data-name="Component 420"
        transform="translate(-18)"
      >
        <path
          id="sign-out-alt"
          fill="#f28440"
          d="M11.53,11.9,9.46,13.96a.9.9,0,1,0,1.278,1.278l3.6-3.6a.93.93,0,0,0,0-1.278l-3.6-3.6A.9.9,0,0,0,9.46,8.039L11.53,10.1H2.9a.9.9,0,1,0,0,1.8ZM11,2A9,9,0,0,0,2.9,6.995a.906.906,0,0,0,1.62.81,7.236,7.236,0,1,1,.036,6.389.906.906,0,0,0-1.62.81A9,9,0,1,0,11,2Z"
          transform="translate(16 -2)"
        />
      </g>
    </SvgIcon>
  );
}

export default CcfForceLogoutIcon;
